.draggableCard {
  cursor: grab;
}

.draggableCard:active {
  cursor: grabbing;
}

.dragging {
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.folderItem {
  cursor: grab;
  border: 1px solid var(--mantine-color-gray-2);
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
}

.folderItem:active {
  cursor: grabbing;
}

.folderItem:hover {
  background-color: var(--mantine-color-gray-0);
  border-color: var(--mantine-color-gray-3);
}

.folderIconBadge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: var(--mantine-color-gray-1);
}

.dropTarget,
.dropTarget:hover {
  background-color: var(--mantine-color-brand-0);
  border-color: var(--mantine-color-brand-6);
}
